import { Text } from '../elements/text.element.jsx';
import { Badge } from '../elements/badge.element.jsx';

export const TraceDisplay = ({ id }) => {
  if (!id) return null;
  return (
    <div className="flex items-center gap-2 opacity-50 hover:opacity-100 transition-opacity">
      <Text variant="label">Trace ID:</Text>
      <Text variant="mono" className="text-[10px]">{id}</Text>
      <Badge label="Debug" status="neutral" />
    </div>
  );
};